import axiosApiClient from "../axios";

const PATH = '/api/camera';

export const getAllCameras = async () => {
    return await axiosApiClient.get(PATH);
};

export const getAllCameraDetails = async () => {
    return await axiosApiClient.get(`${PATH}/detail`);
};

export const getAllCameraById = async (id) => {
    return await axiosApiClient.get(`${PATH}/${id}`);
};

export const getAllCameraByBranchId = async (id) => {
    return await axiosApiClient.get(`${PATH}/${id}/branch`);
};

export const addCamera = async (camera) => {
    try {
        return await axiosApiClient.post(PATH, camera, {});
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Add Camera failed');
    }
};

export const deleteCamera = async (cameraId) => {
    try {
        return await axiosApiClient.delete(`${PATH}/${cameraId}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Delete Camera failed');
    }
};

export const updateCamera = async (cameraId, camera) => {
    try {
        return await axiosApiClient.put(`${PATH}/${cameraId}`, camera, {});
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Update Camera failed');
    }
};

export const updateCameraRoomMapping = async (cameraId, cameraMapping) => {
    try {
        return await axiosApiClient.put(`${PATH}/${cameraId}/room`, cameraMapping, {});
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Update Camera failed');
    }
};

export const removeCameraRoomMapping = async (cameraId) => {
    try {
        return await axiosApiClient.delete(`${PATH}/${cameraId}/room/resign`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Update Camera failed');
    }
};
